import { g as o } from "../../utils-BOfnFgIH.js";
import { I as s } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as n, normalizeClass as r, createElementVNode as e } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMessenger",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(s).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return s[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = o();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = ["fill"], f = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m6.37 14.613 2.754-4.37a1.406 1.406 0 0 1 2.034-.375l2.19 1.643c.2.15.477.15.678-.002l2.958-2.245c.394-.3.91.173.646.592l-2.754 4.37a1.406 1.406 0 0 1-2.034.374l-2.19-1.642a.562.562 0 0 0-.678.002l-2.958 2.245c-.395.3-.91-.173-.646-.592Z",
  fill: "#fff"
}, null, -1), p = ["id"], m = /* @__PURE__ */ e("stop", { "stop-color": "#09F" }, null, -1), h = /* @__PURE__ */ e("stop", {
  offset: ".61",
  "stop-color": "#A033FF"
}, null, -1), g = /* @__PURE__ */ e("stop", {
  offset: ".935",
  "stop-color": "#FF5280"
}, null, -1), v = /* @__PURE__ */ e("stop", {
  offset: "1",
  "stop-color": "#FF7061"
}, null, -1), I = [
  m,
  h,
  g,
  v
];
function S(t, F, l, b, q, a) {
  return n(), i("svg", {
    "aria-label": l.ariaLabel,
    class: r([a.iconSizeClass, "d-icon d-icon--messenger"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Messenger",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 2.86c-5.281 0-9.375 3.868-9.375 9.093 0 2.733 1.12 5.095 2.944 6.726a.75.75 0 0 1 .252.535l.051 1.668a.75.75 0 0 0 1.053.663l1.86-.822a.748.748 0 0 1 .501-.037c.855.236 1.765.36 2.714.36 5.281 0 9.375-3.868 9.375-9.093S17.281 2.86 12 2.86Z",
      fill: `url(#${t.uniqueID}a)`
    }, null, 8, _),
    f,
    e("defs", null, [
      e("radialGradient", {
        id: `${t.uniqueID}a`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(6.234 21.51) scale(20.4299)"
      }, I, 8, p)
    ])
  ], 10, u);
}
const y = /* @__PURE__ */ d(c, [["render", S]]);
export {
  y as default
};
//# sourceMappingURL=messenger.js.map
